export enum ListGroupBy {
    DATE = 'date',
    WORKER = 'worker',
    USER = 'user',
    CUSTOM_PERIOD = 'custom_period',
    LOCALITY = 'locality'
};
